import { call, put, takeLatest } from 'redux-saga/effects';

import { textUpdateError, textUpdateRequest, textUpdateStore } from './textActions.js';
import { updateTextApiCall } from './textAPI.js';

function* updateTextSaga({ payload }) {
  try {
    yield call(updateTextApiCall, payload);
    yield put(textUpdateStore());
  } catch (error) {
    yield put(textUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsTextWatcher() {
  yield takeLatest(textUpdateRequest.type, updateTextSaga);
}
